export default function Upload(FileUploader, Restangular, Authentication) {
  'ngInject';

  const service = this;

  service.uploader = new FileUploader({
    autoUpload: true,
    removeAfterUpload: true,
    url: `${Restangular.configuration.baseUrl}/upload/image`,
    headers: {
      Authorization: Authentication.token,
    },
  });
}
